// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"214":"3a08e841","780":"b97835a2","926":"45bb6da2"}[chunkId] + ".css";
};